<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

import Sidebar from '@/components/Course/Sidebar';
import Info from '@/components/Course/Info';
import Lecture from '@/components/Course/Lecture';
import Video from '@/components/Course/Video';
import Materials from '@/components/Course/Materials';
import Finish from '@/components/Course/Finish';
import Exam from '@/components/Course/Exam';

export default {
  name: 'Home',
  components: {
    Sidebar,
    Info,
    Lecture,
    Video,
    Materials,
    Finish,
    Exam,
  },
  computed: {
    ...mapState('code', {
      course: state => state.course,
      current: state => state.current,
    }),
    ...mapGetters('code', [
      'isLoggedIn',
      'courseComponent',
    ]),
  },
  methods: {
    ...mapActions('code', [
      'fetchUser',
    ]),
    ...mapMutations('code', [
      'reset',
    ]),
  },
  created() {
    this.fetchUser();
  },
};
</script>
<template>
    <div id="course" class="container pt-5">
        <div class="row" v-if="current !== 'exam'">
            <div class="col-lg-4">
                <Sidebar />
            </div>
            <div class="col-lg-8">
                <Component :is="courseComponent" />
            </div>
        </div>
        <Exam v-else />
    </div>
</template>
